module.exports = __webpack_public_path__ + "img/arrow-r.64213c16.svg";